// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxEWmPpJ3lVnAD7e6uD2BjfmkfRv-LlQc",
  authDomain: "titledworks-93303.firebaseapp.com",
  projectId: "titledworks-93303",
  storageBucket: "titledworks-93303.firebasestorage.app",
  messagingSenderId: "468264716897",
  appId: "1:468264716897:web:6f6aee546cabc283933820",
  measurementId: "G-YYNNDEGS00",
  databaseURL: "https://titledworks-93303-default-rtdb.firebaseio.com",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const firestore = getFirestore(app);

export { db, firestore };